import React, {useContext} from "react";
import {Route, Switch} from "react-router-dom";
import RootPage from "../../routes/RootPage";
import {env} from "../../properties";
import HomePage from "../../routes/HomePage";
import NotificationsPage from "../../routes/NotificationsPage";
import UserPage from "../../routes/UserPage";
import ContractDetails from "../../routes/ContractDetails";
import BillingDetailsPage from "../../routes/BillingDetailsPage";
import ErrorTicketDetailsPage from "../errorTicket/ErrorTicketDetailsPage";
import ServiceDetails from "../../routes/ServiceDetails";
import ServerRoomAccessPermitPage from "../serverRoom/ServerRoomAccessPermitPage";
import PageNotFound from "../../routes/PageNotFound";
import {contactHasRight} from "../../utils/commonFunctions";
import PermissionDenied from "../../routes/PermissionDenied";
import {hasAccess} from "../../utils/accessManager";
import {CustomerContext} from "../../context/CustomerContext";
import {useAuth} from "oidc-react";

const NavigationContent = () => {
  const auth = useAuth();
  const customerContext = useContext(CustomerContext);

  const getRoute = (menuItem) => {

    if (!menuItem.children) {
      if (!contactHasRight(customerContext.selectedContact.roles, menuItem.access)) {
        return <Route
          key={"access_denied_" + menuItem.url}
          path={menuItem.url}
          component={PermissionDenied}
        />;
      }
      return <Route
        key={menuItem.url}
        path={menuItem.url}
        component={menuItem.component}
      />;
    }


    return menuItem.children.map(childItem => {
      if (!hasAccess(menuItem.access, auth) || !hasAccess(childItem.access, auth)) {
        return <Route
          key={"access_denied_" + childItem.url}
          path={childItem.url}
          component={PermissionDenied}
        />;
      }
      return <Route
        key={childItem.url}
        path={childItem.url}
        component={childItem.component}
      />;
    });
  };

  return (
    <Switch>
      <Route exact path="/" component={RootPage}/>
      {
        env.menuItems.map(getRoute)
      }
      {
        getRoute({
          url: "/home",
          component: HomePage
        })
      }
      {
        getRoute({
          url: "/notifications",
          component: NotificationsPage
        })
      }
      {
        getRoute({
          url: "/companyDetails",
          component: UserPage
        })
      }
      {
        getRoute({
          url: "/profile",
          component: UserPage
        })
      }
      {
        getRoute({
          url: "/usersAndPermissions",
          component: UserPage
        })
      }
      {
        getRoute({
          url: "/contractDetails/:id",
          component: ContractDetails
        })
      }
      {
        getRoute({
          url: "/billingDetails/:id",
          component: BillingDetailsPage
        })
      }
      {
        getRoute({
          url: "/errorTicketDetails/:id",
          component: ErrorTicketDetailsPage
        })
      }
      {
        getRoute({
          url: "/serviceDetails/:id",
          component: ServiceDetails
        })
      }
      {
        getRoute({
          url: "/serverRoomAccessPermit",
          component: ServerRoomAccessPermitPage
        })
      }
      <Route component={PageNotFound}/>
    </Switch>
  );
};

export default NavigationContent;
